import { WidgetTypeNumeric, WidgetTypes } from 'apps/growthTools/models/Widget/constants'
import { ChannelType } from 'common/core/constants/ChannelType'
import { FsTriggerModel } from 'shared/api/requests/cms/schemas'

import { isIntent, isWidget, triggerType } from './triggerType'
import { FiltersFromQuery } from './types'

export const isWaChannel = (channel?: ChannelType | null) => channel === ChannelType.WHATSAPP

export const isWaKeyword = (query: FiltersFromQuery) =>
  isWaChannel(query.channel) && triggerType(query.trigger_model) && !query.widget_type

export const isWaIntent = (query: FiltersFromQuery) =>
  isWaChannel(query.channel) && isIntent(query.trigger_model) && !query.widget_type

export const isWaRefUrl = (query: FiltersFromQuery) =>
  isWaChannel(query.channel) &&
  isWidget(query.trigger_model) &&
  query.widget_type === WidgetTypeNumeric.MESSENGER_REF_URL

export const isAllWaTriggers = (query: FiltersFromQuery) =>
  isWaChannel(query.channel) && !query.trigger_model && !query.widget_type

export const isTriggerMatchesWaFilter = ({
  widgetType,
  filter,
  triggerModel,
  triggerChannel,
}: {
  widgetType: WidgetTypes | null
  filter: FiltersFromQuery
  triggerModel: FsTriggerModel
  triggerChannel: ChannelType | null
}) =>
  triggerChannel === ChannelType.WHATSAPP &&
  (isAllWaTriggers(filter) ||
    (triggerModel === FsTriggerModel.KEYWORD && isWaKeyword(filter)) ||
    (triggerModel === FsTriggerModel.INTENT && isWaIntent(filter)) ||
    (widgetType === WidgetTypes.MESSENGER_REF_URL && isWaRefUrl(filter)))
